import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark-surface border-t border-dark-border mt-20">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
          {/* About */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-gradient">ReelVindicator</h3>
            <p className="text-gray-400 text-sm mb-4">
              Your trusted source for UK casino reviews and exclusive offers. 
              We help you make informed decisions about online gaming.
            </p>
            
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="text-gray-400 hover:text-accent-primary transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/comparison" className="text-gray-400 hover:text-accent-primary transition-colors">
                  Compare Offers
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-accent-primary transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-400 hover:text-accent-primary transition-colors">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="font-bold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-accent-primary transition-colors">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-accent-primary transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="text-gray-400 hover:text-accent-primary transition-colors">
                  Cookie Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Responsible Gaming */}
          <div>
            <h4 className="font-bold mb-4">Responsible Gaming</h4>
            <div className="space-y-3">
              <a href="https://www.gambleaware.org" target="_blank" rel="noopener noreferrer" className="block">
                <img src="/images/footer/gambleaware.webp" alt="GambleAware" className="h-8 w-auto opacity-80 hover:opacity-100 transition-opacity" loading="lazy" decoding="async" width="120" height="32" />
              </a>
              <a href="https://www.gamcare.org.uk" target="_blank" rel="noopener noreferrer" className="block">
                <img src="/images/footer/gamcare.webp" alt="GamCare" className="h-8 w-auto opacity-80 hover:opacity-100 transition-opacity" loading="lazy" decoding="async" width="120" height="32" />
              </a>
              <a href="https://gamblingtherapy.org" target="_blank" rel="noopener noreferrer" className="block">
                <img src="/images/footer/therapy.webp" alt="Gambling Therapy" className="h-8 w-auto opacity-80 hover:opacity-100 transition-opacity" loading="lazy" decoding="async" width="120" height="32" />
              </a>
              <a href="https://www.gamblingcommission.gov.uk" target="_blank" rel="noopener noreferrer" className="block">
                <img src="/images/footer/commission.webp" alt="Gambling Commission" className="h-8 w-auto opacity-80 hover:opacity-100 transition-opacity" loading="lazy" decoding="async" width="120" height="32" />
              </a>
            </div>
          </div>
        </div>

        {/* 18+ Disclaimer */}
        <div className="border-t border-dark-border pt-8 pb-6">
          <div className="glass p-6 rounded-xl text-center max-w-4xl mx-auto">
            <div className="flex items-center justify-center gap-3 mb-3">
              <span className="text-4xl font-bold text-accent-primary">18+</span>
              <span className="text-xl font-bold text-white">Age Restriction</span>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed">
              This website is intended for users who are 18 years of age or older. Gambling can be addictive. 
              Please play responsibly and only bet what you can afford to lose. If you feel you may have a gambling problem, 
              please seek help from <a href="https://www.gambleaware.org" target="_blank" rel="noopener noreferrer" className="text-accent-primary hover:underline">GambleAware</a>, 
              <a href="https://www.gamcare.org.uk" target="_blank" rel="noopener noreferrer" className="text-accent-primary hover:underline ml-1">GamCare</a>, or 
              <a href="https://gamblingtherapy.org" target="_blank" rel="noopener noreferrer" className="text-accent-primary hover:underline ml-1">Gambling Therapy</a>.
            </p>
          </div>
        </div>

        <div className="border-t border-dark-border pt-6 pb-8 text-center text-sm text-gray-500">
          <p>&copy; {currentYear} ReelVindicator.com. All rights reserved. | 18+ Only | BeGambleAware.org</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

